import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { AdminDeploymentRecord } from 'app/records/admin.deployment.records';
import { AdminDeploymentsService } from 'app/services/admin.deployments.service';
import { AdminHealthService } from 'app/services/admin.health.service';
import { LoggerService, LogLevel } from 'app/services/logger.service';
import { Status } from 'app/records/status.record';

/* eslint-disable  @typescript-eslint/no-explicit-any */

@Component({
    selector: 'admin-deployments',
    templateUrl: './admin-deployments.component.html',
    styleUrls: ['./admin-deployments.component.scss'],
    imports: [CommonModule]
})
export class AdminDeploymentsComponent implements OnInit {
    readonly healthData = signal<any>(undefined);
    readonly deployments = signal<AdminDeploymentRecord[]>([]);

    readonly loading = signal<boolean>(false);
    readonly error = signal<string | null>(null);

    readonly lastKey = signal<string>('');
    readonly hasMoreRecords = signal<boolean>(true);

    healthService = inject(AdminHealthService);
    deploymentsService = inject(AdminDeploymentsService);

    logger: ReturnType<LoggerService['getScopedLogger']>;
    loggerService = inject(LoggerService);

    Status = Status; // expose this enum to html component

    constructor() {
        this.loggerService.setLogLevel('AdminDeploymentsComponent', LogLevel.DEBUG);
        this.logger = this.loggerService.getScopedLogger('AdminDeploymentsComponent');
    }

    ngOnInit(): void {
        this.loadHealth();
        this.loadDeployments();
    }

    loadHealth(): void {
        this.healthService.getHealth().subscribe({
            next: (data) => {
                this.logger.debug(data);
                this.healthData.set(data);
            },
            error: (err) => {
                this.error.set(`API connection failed: \n ${JSON.stringify(err, null, 2)}`);
                this.logger.error(this.error());
            }
        });
    }

    loadDeployments(lastKey: string = '') {
        if (this.loading()) return;
        this.loading.set(true);

        this.deploymentsService.all(lastKey).subscribe({
            next: (response) => {
                this.deployments.update((deployments: AdminDeploymentRecord[]) => [...deployments, ...(response.items ?? [])]);
                this.lastKey.set(response.lastKey);
                this.loading.set(false);
                this.hasMoreRecords.set(!!response.lastKey);
            },
            error: () => {
                this.loading.set(false);
            }
        });
    }

    loadNextPage() {
        if (!this.lastKey()) return;
        this.loadDeployments(this.lastKey());
    }
}
